import { forwardRef, type Ref, type SVGProps } from "react";
const IconProfileOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M26 8.59 20.41 3A3.73 3.73 0 0 0 18 2H7a2.006 2.006 0 0 0-2 2v24a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V11a3.73 3.73 0 0 0-1-2.41m-7-4.18L24.59 10H19ZM25 28H7V4h10v7a1 1 0 0 0 1 1h7Z" />
    <path d="M20 18h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2m0 4h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2m-8-12a2 2 0 1 0 0 4 2 2 0 1 0 0-4m4 10h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m0 4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-6-6a1 1 0 0 0 1-1v-1h2v1a1 1 0 0 0 2 0v-1a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1a1 1 0 0 0 1 1m10 8h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2" />
  </svg>
);
const ForwardRef = forwardRef(IconProfileOutlineSVG);
ForwardRef.displayName = "IconProfileOutline";
export { ForwardRef as IconProfileOutline };
